<template>
    <div>
        <div class="page-top mb-1 mb-3">
            <h1> Edit City</h1>
        </div>
        <div class="global-main">
            <form @submit.prevent="editFaqCategoryData">
                <div class="tab-content-inner">
                    <div class="form-group">
                        <label> Name </label>
                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                        <has-error :form="form" field="name"></has-error>
                    </div>
                </div>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/faqsCategory" class="btn btn-primary float-right mr-2">Cancel</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                }),
            };
        },
        methods: {
            editFaqCategoryData() {
                this.$Progress.start();
                this.form.put('/api/updateFaqCategoryAPI')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                        this.showToastBox('success','FAQ Category updated successfully');
                        this.$router.push('/faqsCategory');
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },

        },
        mounted() {

        },
        created() {
            this.$Progress.start();
            axios.get('/api/editFaqCategory/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.id;
                        this.form.name = res.data.name;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
        }
    }
</script>
